import { useMutation } from "@tanstack/react-query";
import { useErrorCodeMap } from "libs/react-query/hooks/useErrorCodeMap";
import { postCheckVerificationCode, postPhoneVerificationCode } from "./phone.handler";
import { queryClient } from "libs/react-query/queryClient";
import queryKeys from "libs/react-query/query_key";

/** 인증 코드 요청 POST */
export const usePostPhoneVerificationCode = () => {
  const errorCodeMap = useErrorCodeMap();
  return useMutation({
    mutationFn: postPhoneVerificationCode,
    meta: {
      errorCodeMap,
    },
  });
};

/** 코드 전송 및 업데이트 POST */
export const usePostCheckVerificationCode = () => {
  const errorCodeMap = useErrorCodeMap();
  return useMutation({
    mutationFn: postCheckVerificationCode,
    meta: {
      errorCodeMap,
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_MY_ACCOUNT_INFO],
      });
    },
  });
};
